import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const CircleCrown = (props: Icon) => {
    const {
        color = 'white',
        background = colors.yellow,
        size = 40,
        className = 'circle-crown'
    } = props

    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 40 40"
            preserveAspectRatio="none">
            <g fill="none" fillRule="evenodd">
                <circle cx={20} cy={20} r={20} fill={background} />
                <path
                    fill={color}
                    d="M20.19 23.654c4.993 0 8.375 1.167 8.965 2.106-.94 1.28-4.59 2.22-8.964 2.22-4.375 0-8.053-.94-8.965-2.22.59-.939 3.945-2.106 8.965-2.106zm-.08-11.725c.134-.199.403-.199.537 0l3.704 6.347c.107.17.322.227.483.085l4.026-3.586c.188-.199.51-.028.51.256v9.534c-1.637-1.366-5.368-2.05-9.206-2.05-3.704 0-7.596.77-9.314 2.05V15.03c0-.284.295-.455.51-.284l4.402 3.728c.134.114.349.085.456-.086l3.892-6.46z"
                />
            </g>
        </svg>
    )
}

export { CircleCrown }
